import { Phone, MessageSquare, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

export function CallOrTextButton() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="goldOutline" size="xl" className="flex items-center gap-2">
          <Phone className="h-5 w-5" />
          Call or Text (973) 725-2395
          <ChevronDown className="h-4 w-4 ml-1" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-2 bg-background border-border" align="center">
        <a
          href="tel:+19737252395"
          className="flex items-center gap-2 w-full px-3 py-2 rounded-md hover:bg-accent text-foreground font-medium"
        >
          <Phone className="h-4 w-4 text-secondary" />
          Call (973) 725-2395
        </a>
        <a
          href="sms:+19737252395"
          className="flex items-center gap-2 w-full px-3 py-2 rounded-md hover:bg-accent text-foreground font-medium"
        >
          <MessageSquare className="h-4 w-4 text-secondary" />
          Text (973) 725-2395
        </a>
      </PopoverContent>
    </Popover>
  );
}